module.exports = __webpack_public_path__ + "static/media/jollylube.11b99212.png";